<template>
  <div class="container">
    <div
      v-if="$store.state.typeParam == 1"
      class="header"
    >
      <div class="logo">
        <img
          border="0"
          src="@/assets/images/logo.png"
        />
      </div>
      <div class="button">
        <a
          href="http://appdownload.hunzhi.com/?channel=002"
          target="blank"
        >下载APP</a>
      </div>
    </div>
    <div v-if="$store.state.typeParam == 1">
      <vue-aliplayer-v2
        class="player"
        :source="$store.state.videoContent.playUrl"
        ref="VueAliplayerV2"
        :options="options"
      />
    </div>
    <div v-else>
      <div class="player-sec">
        <div class="title-row">
          <span class="title">{{$store.state.videoContent.title}}</span>
          <span class="status">试听</span>
        </div>
        <div class="cover">
          <img
            class="coverImgUrl"
            :src="$store.state.videoContent.coverUrl"
            alt
          />
        </div>
        <vue-aliplayer-v2
          class="player audio-player"
          :source="$store.state.videoContent.playUrl"
          ref="VueAliplayerV2"
          :options="audioOptions"
        />
      </div>
    </div>
    <div class="tab">
      <div class="introduction">
        <router-link
          :to="{name: 'Introduction',query:{courseId:$store.state.courseIdParam,type:$store.state.typeParam}}"
          exact
          ref="intro"
          active-class="router-active"
          :class="{'router-active':$route.name==='Introduction'}"
        >简介</router-link>
      </div>
      <div class="comment">
        <router-link
          :to="{name: 'Comment',query:{courseId:$store.state.courseIdParam,type:$store.state.typeParam}}"
          active-class="router-active"
        >留言 {{$store.state.comments.length}}</router-link>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
// @ is an alias to /src
import VueAliplayerV2 from "vue-aliplayer-v2";
export default {
  name: "Video",
  components: {
    VueAliplayerV2: VueAliplayerV2.Player,
  },
  data() {
    const skinLayout = [
      { name: "bigPlayButton", align: "blabs", x: 30, y: 80 },
      {
        name: "H5Loading",
        align: "cc",
      },
      { name: "errorDisplay", align: "tlabs", x: 0, y: 0 },
      { name: "infoDisplay" },
      { name: "tooltip", align: "blabs", x: 0, y: 56 },
      { name: "thumbnail" },
      {
        name: "controlBar",
        align: "blabs",
        x: 0,
        y: 0,
        children: [
          { name: "progress", align: "blabs", x: 0, y: 44 },
          { name: "playButton", align: "tl", x: 15, y: 12 },
          { name: "timeDisplay", align: "tl", x: 10, y: 7 },
          { name: "fullScreenButton", align: "tr", x: 10, y: 12 },
        ],
      },
    ];
    const skinLayoutAudio = [
      { name: "bigPlayButton", align: "blabs", x: 30, y: 80 },
      {
        name: "H5Loading",
        align: "cc",
      },
      { name: "errorDisplay", align: "tlabs", x: 0, y: 0 },
      { name: "infoDisplay" },
      { name: "tooltip", align: "blabs", x: 0, y: 56 },
      { name: "thumbnail" },
      {
        name: "controlBar",
        align: "blabs",
        x: 0,
        y: 0,
        children: [
          { name: "progress", align: "blabs", x: 0, y: 44 },
          { name: "playButton", align: "tl", x: 15, y: 12 },
          { name: "timeDisplay", align: "tl", x: 10, y: 7 },
        ],
      },
    ];
    return {
      options: {
        controlBarVisibility: "always",
        cover: this.$store.state.videoContent.coverUrl,
        skinLayout: skinLayout,
      },
      audioOptions: {
        height: "0",
        videoHeight: "0",
        controlBarVisibility: "always",
        skinLayout: skinLayoutAudio,
      },
    };
  },
  mounted() {
    this.play();
  },

  methods: {
    play() {},
  },
};
</script>

<style lang="scss" scoped>
.container {
  .header {
    background-color: rgba(26, 30, 36, 0.8);
    position: sticky;
    top: 0;
    left: 0;
    z-index: 999999;
    height: 80px;
    width: 100vw;
    padding: 12px 7px 12px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo {
      img {
        display: block;
        height: 70px;
        width: 70px;
      }
    }
    .button {
      padding: 12px 24px;
      background-color: rgba(204, 86, 56, 1);
      border-radius: 30px;

      a {
        display: block;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(243, 252, 243, 1);
      }
    }
  }
  .player-sec {
    background: rgba(54, 96, 98, 1);
    // padding-bottom: 32px;
    .title-row {
      display: flex;
      justify-content: center;
      .title {
        padding-top: 24px;
        text-align: center;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 24px;
      }
      .status {
        background: rgba(218, 72, 46, 1);
        border-radius: 2px;
        border: 1px solid rgba(218, 72, 46, 1);

        margin-top: 27px;
        margin-left: 7px;

        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 15px;
        height: 17px;
      }
    }

    .cover {
      display: flex;
      justify-content: center;
      max-height: 318px;
      img.coverImgUrl {
        width: 60% !important;
        height: auto !important;
        margin-bottom: 80px;
        // margin: 12px 0px 42px 0px;
        box-shadow: 0px 4px 22px 0px rgba(0, 0, 0, 0.5);
        border-radius: 7px;
      }
    }

    .player {
      height: 48px;
    }

    .audio-player {
      background: rgba(54, 96, 98, 1);
    }
  }
}

.tab {
  height: 40px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;

  > div {
    font-size: 14px;
    font-weight: 400;
    color: rgba(218, 72, 46, 1);
    line-height: 20px;
  }

  .introduction {
    margin: 0px 28px 0px 28px;
    padding: 10px 0px 10px 0px;
  }

  .comment {
  }

  a {
    color: rgba(190, 190, 190, 1);
    line-height: 20px;
  }

  .router-active {
    color: rgba(218, 72, 46, 1);
    padding-bottom: 7px;
    border-bottom: solid;
  }
}
</style>
